import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonWrapper } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

const mapStateToProps = (state: ApplicationState) => ({
    
});

const mapDispatchToProps = {};

export interface OrderHistorySearchFormStyles {
    container?: GridContainerProps;
    titleGridItem?: GridItemProps;
    orderDetailsInfoGridItem?: GridItemProps;
    orderDetailsSummaryGridItem?: GridItemProps;
    orderDetailsInfo?: InjectableCss;
}

export const searchFormStyles: OrderHistorySearchFormStyles = {
    container: {
        css: css`
            
        `,
    },
    titleGridItem: {
        width: [12, 12, 12, 12, 12],
        css:css`
            [data-test-selector="orderDetails_standardButtons"]{
                ${ButtonWrapper} {
                    background-color: #999;
                    color: #fff;
                    border: 1px solid #999;
                    :hover {
                        opacity: .9;
                    }
                }
                [data-test-selector="orderDetails_reorderButton"] {
                    background: #005cb9 !important;
                    border: 1px solid #005cb9;
                }
            }
        `
    },
    orderDetailsInfoGridItem: {
        width: [12, 12, 7, 7, 7],
        css:css`
        `
    },
    orderDetailsSummaryGridItem: {
        width: [12, 12, 5, 5, 5],
        css:css`
            ${GridWrapper} {
                margin-bottom: 1.5em;
                border: 1px solid #dcdcdc;
                padding: 1em;
                background-color: #ffffff;
            }
        `
    },
    orderDetailsInfo: {
        css: css`
            margin-bottom: 1.5em;
            border: 1px solid #dcdcdc;
            padding: 1em;
            width: 100%;
        `
    }
};

const styles = searchFormStyles;

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const OrderDetailsContainer = ({
    id,
  }: Props) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.titleGridItem} data-test-selector="titleGridItem">
                <Zone contentId={id} zoneName="Content" />
            </GridItem>
            <GridItem {...styles.orderDetailsInfoGridItem} data-test-selector="orderDetailsInfoGridItem">
                <StyledWrapper {...styles.orderDetailsInfo}>
                    <Zone contentId={id} zoneName="Content0" />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.orderDetailsSummaryGridItem} data-test-selector="orderDetailsSummaryGridItem">
                <Zone contentId={id} zoneName="Content1" />
            </GridItem>
        </GridContainer>
    );
  };
  
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderDetailsContainer),
    definition: {
        group: "Order Details",
        displayName: "Order Details Conatiner",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
